import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import { useMediaQuery } from '@react-hook/media-query';
import React from 'react';

export interface Color {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

export interface ColorScheme {
  brand: Color;
  gray: Color;
  white: string;
  black: string;
  focus?: string;
  hover?: string;
  body: string;
}

export const colorSchemeIdentifiers = ['light', 'dark'] as const;
export type ColorSchemeIdentifier = 'light' | 'dark';

export function isColorSchemeIdentifier(value: string): value is ColorSchemeIdentifier {
  return value === 'light' || value === 'dark';
}

const PreferredColorSchemeContext = React.createContext<ColorSchemeIdentifier | undefined>(undefined);

export const PreferredColorSchemeProvider = PreferredColorSchemeContext.Provider;

export const MediaQueryPreferredColorSchemeProvider: React.FC<{ children?: React.ReactNode }> = (props) => {
  const matches = useMediaQuery('(prefers-color-scheme: dark)');
  const { children } = props;
  return <PreferredColorSchemeProvider value={matches ? 'dark' : 'light'}>{children}</PreferredColorSchemeProvider>;
};

export const usePreferredColorScheme = createUseContext('PreferredColorSchemeContext', PreferredColorSchemeContext);
